module.exports = __webpack_public_path__ + "img/home-illustrazione-01@2x.f191902a.png";